import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=ac55778a&scoped=true&"
import script from "./Presupuestos.vue?vue&type=script&lang=js&"
export * from "./Presupuestos.vue?vue&type=script&lang=js&"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=ac55778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac55778a",
  null
  
)

export default component.exports